import "./ReportBox.scss"
import {RaikoCustomTooltip, RaikoLabel} from "@moeindal/base-raiko-panel-components";
import pdf from "../../assets/svg/fileTypeIcon/ic-pdf.svg"
import excel from "../../assets/svg/fileTypeIcon/ic-xlx.svg"
import doc from "../../assets/svg/fileTypeIcon/ic-doc.svg"
import {css} from "@emotion/css";



export const ReportBox = ({types = [ReportBoxItemTypes.PDF], label, handleOnClick}) => {


    return (
        <div className={"reportBoxContainer"} >
            <RaikoLabel text={label} className={"reportBoxLabel"}/>
            <div className={"reportBoxItemsIconContainer"}>
                {
                    types.map((type, index) => {
                        return <RaikoCustomTooltip title={type ? type.type :""} key={index}>
                            <img
                                className={css`width: 64px`}
                                src={type ? type.icon : ""}
                                alt={type ? type.type : ""}
                                onClick={_ => handleOnClick(type.type)}
                            />
                        </RaikoCustomTooltip>
                    })
                }
            </div>
        </div>
    )
}

export const ReportBoxItemTypes = {
    PDF: {
        id: "PDF",
        type: "pdf",
        icon: pdf
    },
    XLSX: {
        id: "XLSX",
        type: "xlsx",
        icon: excel
    },
    DOC: {
        id: "DOC",
        type: "DOC",
        icon: doc
    },
}